import {FormController} from '../classes/form-controller';

const axios = require('axios');

export default class extends FormController {
	static targets = ['form', 'field', 'input', 'otherAmount'];

	connect() {
	}

	/**
	 * Select amount from dropdown
	 *
	 * @param {Event} e
	 */
	selectAmount(e) {
		e.preventDefault();
		const amount = e.target.value;

		if (amount === 'other') {
			this.otherAmountTarget.classList.remove('hidden');
		} else if (!this.otherAmountTarget.classList.contains('hidden')) {
			this.otherAmountTarget.classList.add('hidden');
		}
	}

	/**
	 * Submit download form.
	 *
	 * @param {Event} e
	 */
	submit(e) {
		e.preventDefault();
		const formData = new FormData(this.formTarget);

		this.formTarget.setAttribute('data-group-loading', 'true');

		axios.post(
			supersage.ajaxURL,
			formData
		)
			.then((response) => {
				if (response.data.status === 'error') {
					this.displayErrors(response.data.errors);
					this.formTarget.removeAttribute('data-group-loading');
				}

				if (response.data.status === 'success') {
					if (response.data.mollie_url !== undefined) {
						document.location.href = response.data.mollie_url;
					} else if (response.data.thanks_url !== undefined) {
						document.location.href = response.data.thanks_url;
					}
				} else {
					console.log(response.data.status);
				}
			})
			.catch((error) => {
				console.log(error);
				this.formTarget.removeAttribute('data-group-loading');
			});
	}

	triggerSuccessState() {
		this.successNoticeTarget.classList.remove('hidden');

		this.inputTargets.forEach(function (inputTarget) {
			inputTarget.value = '';
		});

		this.formTarget.classList.add('hidden');

		var headerOffset = 45;
		var elementPosition = this.successNoticeTarget.getBoundingClientRect().top;
		var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

		window.scrollTo({
			top: offsetPosition,
			behavior: "smooth",
		});
	}


}
